<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
      <div class="d-flex justify-end align-center">
        <v-text-field
          v-model="search"
          class="mr-3"
          append-icon="mdi-magnify"
          label="Buscar..."
          solo
          rounded
          hide-details
          flat
          dense/>
        <template>
          <v-btn
            rounded
            class="mr-3"
            small
            depressed
            text
            color="primary"
            @click="downloadXML">
            Descargar XMLs
          </v-btn>
        </template>
        <template>
          <v-btn
            rounded
            class="mr-3 white--text"
            small
            depressed
            color="primary"
            target="_blank"
            :href="downloadBankStatement">
            Descargar estado de cuenta
          </v-btn>
        </template>
        <v-tooltip left>
          <template
            v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :href="exportRoute"
              target="_blank"
              dark
              fab
              x-small
              depressed
              color="secondary">
              <v-icon color="white">mdi-application-export</v-icon>
            </v-btn>
          </template>
          <span>Exportar movimientos a CSV</span>
        </v-tooltip>
      </div>
    </div>

    <div class="px-3">
      <v-row>
        <v-col>
          <v-card
            class="pa-3"
            tile>
            <div v-if="!loadingBalance">
              <div class="subtitle-2">
                Saldo disponible:
              </div>
              <div
                class="primary--text title">
                {{ balance.get('amountAvailable') | toFixNumber(2) | prefix('$') | numberWithComma }}
              </div>
              <v-divider />
              <div class="subtitle-2">
                Saldo congelado:
              </div>
              <div
                class="primary--text title">
                {{ balance.get('amountWithheld') | toFixNumber(2) | prefix('$') | numberWithComma }}
              </div>
            </div>
            <loader :loading="loadingBalance"></loader>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            class="pa-3"
            tile>
            <div v-if="!initialAndLastBalance.loading">
              <div class="subtitle-2">
                Saldo al inicio de mes:
              </div>
              <div
                class="primary--text title">
                {{ initialAndLastBalance.data.start | toFixNumber(2) | prefix('$') | numberWithComma }}
              </div>
              <v-divider />
              <div class="subtitle-2">
                Saldo al final de mes:
              </div>
              <div
                class="primary--text title">
                {{ initialAndLastBalance.data.end | toFixNumber(2) | prefix('$') | numberWithComma }}
              </div>
            </div>
            <loader :loading="initialAndLastBalance.loading"></loader>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            class="pa-3"
            tile>
            <div v-if="!summaryBalance.loading">
              <v-row>
                <v-col cols="4" class="pa-1">
                  <div class="subtitle-2">
                    Compras:
                  </div>
                  <div
                    class="primary--text">
                    {{ summaryBalance.data.purchases | toFixNumber(2) | prefix('$') | numberWithComma }}
                  </div>
                </v-col>
                <v-col cols="4" class="pa-1">
                  <div class="subtitle-2">
                    Abonos:
                  </div>
                  <div
                    class="primary--text">
                    {{ summaryBalance.data.balancePayment | toFixNumber(2) | prefix('$') | numberWithComma }}
                  </div>
                </v-col>
                <v-col cols="4" class="pa-1">
                  <div class="subtitle-2">
                    Comisiones:
                  </div>
                  <div
                    class="primary--text">
                    {{ summaryBalance.data.comissions | toFixNumber(2) | prefix('$') | numberWithComma }}
                  </div>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-divider />
                </v-col>
                <v-col cols="4" class="pa-1">
                  <div class="subtitle-2">
                    Otras salidas:
                  </div>
                  <div
                    class="primary--text">
                    {{ summaryBalance.data.outputs | toFixNumber(2) | prefix('$') | numberWithComma }}
                  </div>
                </v-col>
                <v-col cols="4" class="pa-1">
                  <div class="subtitle-2">
                    Otras entradas:
                  </div>
                  <div
                    class="primary--text">
                    {{ summaryBalance.data.inputs | toFixNumber(2) | prefix('$') | numberWithComma }}
                  </div>
                </v-col>
              </v-row>
            </div>
            <loader :loading="summaryBalance.loading"></loader>
          </v-card>
        </v-col>

      </v-row>
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [30, 50, 100, 150]
        }"
        sort-by="name"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:top>
          <div class="px-3 filters">
            <v-row>
              <v-col cols="3">
                <div class="d-flex align-center">
                  <span class="mr-3">
                    Filtros:
                  </span>
                  <v-menu
                    ref="datePicker"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="range"
                        label="Rango de fechas"
                        prepend-icon="mdi-calendar"
                        readonly
                        hide-details
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates"
                      :range="true"
                      first-day-of-week="1"
                      no-title
                    >
                      <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                      <v-spacer/>
                      <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                      <v-btn :disabled="dates.length < 2" color="primary" @click="filterByDate">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ item.createdAt | toDate() }}
        </template>
        <template v-slot:item.notes="{ item }">
          <a href=""
            v-if="item.notes !== 'Comisión por manejo de saldo' && item.metadata && item.metadata.order && item.metadata.order.orderRefunded"
            @click.prevent="openRefundDialog(item)">
            {{ item.notes }}
          </a>
          <a href=""
            v-else-if="item.notes !== 'Comisión por manejo de saldo' && item.metadata && item.metadata.order"
            @click.prevent="openDialog(item)">
            {{ item.notes }}
          </a>
          <div v-else>
            {{ item.notes }}
          </div>
        </template>
        <template v-slot:item.accountingDate="{ item }">
          {{ item.updatedAt | toDate() }}
        </template>
        <template v-slot:item.status="{ item }">
          <div v-if="item.metadata && item.metadata.order" :class="`${statusColor(item.metadata.order.status)}--text`">
            {{ statusName(item.metadata.order.status) }}
          </div>
        </template>
        <template v-slot:item.invoice="{ item }">
          <div
            v-if="item.metadata && item.metadata.order && item.metadata.order.invoices.length"
            :class="checkTotal(item.metadata.order.total, item.metadata.order.invoicedTotal) ? 'primary--text' : 'red--text'">
            {{item.metadata.order.invoicedTotal | toFixNumber(2) | numberWithComma  | prefix('$') }}
            <v-icon v-if="checkTotal(item.metadata.order.total, item.metadata.order.invoicedTotal)" color="primary">
              mdi-check
            </v-icon>
            <v-icon v-else color="red">
              mdi-close
            </v-icon>
          </div>
          <div v-if="item.metadata && item.metadata.order && item.metadata.order.invoices.length === 0 && item.metadata.order.waitForInvoice">
            -
          </div>
        </template>
        <template v-slot:item.folio="{ item }">
          <div v-if="item.metadata && item.metadata.order && item.metadata.order.invoices.length > 0">
            {{ item.metadata.order.invoices ? item.metadata.order.invoices[0].folio : '' }}
          </div>
          <div v-if="item.metadata && item.metadata.order && item.metadata.order.invoices.length === 0 && item.metadata.order.waitForInvoice">
            Recibida sin factura
          </div>
        </template>
        <template v-slot:item.fiscal="{ item }">
          <div v-if="item.metadata && item.metadata.order && item.metadata.order.invoices.length > 0">
            {{ item.metadata.order.invoices ? item.metadata.order.invoices[0].uuid : '' }}
          </div>
          <div v-if="item.metadata && item.metadata.order && item.metadata.order.invoices.length === 0 && item.metadata.order.waitForInvoice">
            -
          </div>
        </template>
        <template v-slot:item.datePayment="{ item }">
          <div v-if="item.metadata && item.metadata.order && item.metadata.order.status === 'paid' && !item.notes.includes('Comisión por manejo de saldo')">
            {{ item.metadata.order.updatedAt | toDate() }}
          </div>
          <div v-else-if="item.metadata && item.metadata.order && item.metadata.order.status !== 'paid' && !item.notes.includes('Comisión por manejo de saldo')">
            Pediente de pago
          </div>
          <div v-else>
            -
          </div>
        </template>
        <template v-slot:item.payment="{ item }">
          {{ item.payment | toFixNumber(2) | numberWithComma  | prefix('$') }}
        </template>
        <template v-slot:item.deposit="{ item }">
          {{ item.deposit | toFixNumber(2) | numberWithComma | prefix('$') }}
        </template>
        <template v-slot:item.balance="{ item }">
          {{ (item.balanceAmount + item.deposit - item.payment) | toFixNumber(2) | numberWithComma | prefix('$') }}
        </template>
        <template v-slot:item.xml="{ item }">
          <div class="d-flex" v-if="countryRestaurant === 'MX'">
            <div v-if="item.metadata && item.metadata.order && item.metadata.order.invoices.length > 0">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mr-3"
                    fab
                    color="primary"
                    x-small
                    depressed
                    @click="viewInvoice(item.metadata.order._id, item.metadata.order.invoices[0])">
                    <v-icon>
                      mdi-receipt
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ver Factura</span>
              </v-tooltip>
            </div>
            <div v-if="item.metadata && item.metadata.order && item.metadata.order.invoices.length > 0">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mr-3"
                    fab
                    color="info"
                    x-small
                    depressed
                    @click="downloadInvoice(item.metadata.order._id, item.metadata.order.invoices[0])">
                    <v-icon>
                      mdi-xml
                    </v-icon>
                  </v-btn>
                </template>
                <span>Descargar XML</span>
              </v-tooltip>
            </div>
            <div v-if="item.metadata && item.metadata.order && item.metadata.order.invoices.length === 0 && item.metadata.order.waitForInvoice">
              -
            </div>
          </div>
          <div v-else>
            <div v-if="(item.metadata || {}).order">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mr-3"
                    fab
                    color="primary"
                    x-small
                    depressed
                    tag="a"
                    target="_blank"
                    :href="downloadOrderInvoice(item.metadata.order._id)">
                    <v-icon color="white">
                      mdi-pdf-box
                    </v-icon>
                  </v-btn>
                </template>
                <span>Descargar Factura</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <detail-dialog
      :dialog="dialog"
      :order="order"
      v-on:update:order="order = $event"
      @close="closeDialog"/>

    <refund-dialog
      :dialog="refundDialog"
      :order="orderRefunded"
      v-on:update:order="order = $event"
      @close="closeRefundDialog"/>

    <InvoiceViewer
      ref="invoice"
      :order="order"
      @close="closeInvoiceViewer"/>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import DetailDialog from '@/screens/purchaseOrders/Detail'
import RefundDialog from '@/components/sidePanels/RefundOrder'
import Balance from '@/models/Balance'
import moment from 'moment'
import Loader from '@/components/Loader'
import { mapGetters } from 'vuex'

export default {
  name: 'BalanceMovements',
  components: {
    InvoiceViewer,
    DetailDialog,
    RefundDialog,
    Loader
  },
  data () {
    let balance = new Balance()

    return {
      dialog: false,
      refundDialog: false,
      overlay: false,
      datePicker: false,
      month: new Date().toISOString(),
      section: this.$i18n.t('balance.section'),
      balance,
      loadingBalance: false,
      table: {
        title: this.$i18n.t('balance.loading'),
        loading: true,
        data: [],
        total: 1,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 50,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      initialAndLastBalance: {
        loading: false,
        data: {}
      },
      summaryBalance: {
        loading: false,
        data: {}
      },
      search: '',
      invoiceViewerOpen: false,
      order: {},
      orderRefunded: {},
      orderPanel: false,
      dates: [
        this.$moment().startOf('month').format('YYYY-MM-DD'),
        this.$moment().endOf('month').format('YYYY-MM-DD')
      ]
    }
  },
  computed: {
    ...mapGetters({
      countryRestaurant: 'currentRestaurant/country'
    }),
    headers () {
      const headers = [
        { text: this.$i18n.t('balance.headers.date'), value: 'createdAt', sortable: false },
        { text: this.$i18n.t('balance.headers.concept'), value: 'notes', sortable: false }
      ]

      if (this.countryRestaurant === 'MX') {
        headers.push(...[
          { text: this.$i18n.t('balance.headers.invoice'), value: 'invoice', sortable: false, align: 'right' },
          { text: this.$i18n.t('balance.headers.folio'), value: 'folio', sortable: false },
          { text: this.$i18n.t('balance.headers.fiscal'), value: 'fiscal', sortable: false, align: 'right' }
        ])
      }

      headers.push(...[
        { text: this.$i18n.t('balance.headers.datePayment'), value: 'datePayment', sortable: false, align: 'right' },
        { text: this.$i18n.t('balance.headers.payment'), value: 'payment', align: 'right', sortable: false },
        { text: this.$i18n.t('balance.headers.amountPaid'), value: 'deposit', align: 'right', sortable: false },
        { text: this.$i18n.t('balance.headers.balance'), value: 'balance', align: 'right', sortable: false },
        { text: this.$i18n.t('balance.headers.actions'), value: 'xml', sortable: false }
      ])
      return headers
    },
    movementsPermissions () {
      return this.$store.state.login.permissions['my-management'].components['movements-list'].actions
    },
    range () {
      return this.dates.length < 2 ? '' : `${this.dates[0]} / ${this.dates[1]}`
    },
    exportRoute () {
      const dates = this.dates.length === 2
        ? [this.$moment(this.dates[0]).startOf('day').toISOString(), this.$moment(this.dates[1]).endOf('day').toISOString()]
        : [null, null]
      let url = `${process.env.VUE_APP_API_URL}/v1/balances/export`
      url += `?output=file&access_token=${this.$store.state.login.token}`
      url += `&restaurant=${this.$store.state.currentRestaurant.data._id}`
      url += `&createdAt>=${dates[0]}&createdAt<=${dates[1]}`
      return url
    },
    downloadBankStatement () {
      const dates = this.dates.length === 2
        ? [this.$moment(this.dates[0]).startOf('day').toISOString(), this.$moment(this.dates[1]).endOf('day').toISOString()]
        : [null, null]
      let url = `${process.env.VUE_APP_API_URL}/v1/balances/bank-statement`
      url += `?access_token=${this.$store.state.login.token}`
      url += `&restaurant=${this.$store.state.currentRestaurant.data._id}`
      url += `&createdAt>=${dates[0]}&createdAt<=${dates[1]}`
      return url
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  watch: {
    // ... Watch out! Be Careful
    'search': async function (val) {
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }
      if (val.length >= 3) {
        try {
          params.notes = `/${val}/i`
          await this.load(params)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        this.load(params)
      }
    },
    restaurant: {
      handler: async function (newVal, oldVal) {
        if (newVal._id && newVal._id !== oldVal._id) {
          await this.load()
        }
      },
      deep: true
    }
  },
  mounted: async function () {
    await Promise.all([
      this.loadAvailableBalance(),
      this.loadInitialAndLastBalance(),
      this.loadSummaryBalance()
    ])
  },
  methods: {
    downloadOrderInvoice (orderId) {
      let url = `${process.env.VUE_APP_API_URL}/v1/orders/${orderId}/download-invoice-pdf`
      url += `?access_token=${this.$store.state.login.token}`
      return url
    },
    openDialog (item) {
      this.order = item.metadata.order
      this.dialog = true
      this.refundDialog = false
    },
    openRefundDialog (item) {
      this.orderRefunded = item.metadata.order
      this.dialog = false
      this.refundDialog = true
    },
    async downloadXML () {
      this.overlay = true
      const startDate = moment(this.dates[0])
      const endDate = moment(this.dates[1])
      if (endDate.diff(startDate, 'months', true) > 2) {
        this.$toasted.show(`El rango de fecha ${startDate.format('YYYY-MM-DD')} | ${startDate.format('YYYY-MM-DD')} es mayor a 2 meses, intenta con un rango máximo de 2 meses para continuar.`, { duration: 6000 })
      } else if (this.dates.length === 0) {
        this.$toasted.show(`Seleccione un rango de fechas.`, { duration: 6000 })
      } else {
        try {
          await this.$api.get(`/v1/balances/export?zip=zip&access_token=${this.$store.state.login.token}&restaurant=${this.$store.state.currentRestaurant.data._id}&createdAt>=${startDate.startOf('day').toISOString() || ''}&createdAt<=${endDate.endOf('day').toISOString() || ''}`)
          this.$toasted.show('Se enviará a su correo el link para descargar las facturas emitadas', { duration: 3000, type: 'success' })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      }
      this.overlay = false
    },
    async resetDate () {
      this.dates = [
        this.$moment().startOf('month').format('YYYY-MM-DD'),
        this.$moment().endOf('month').format('YYYY-MM-DD')
      ]
      await this.load()
      await this.loadInitialAndLastBalance()
      await this.loadSummaryBalance()
      this.datePicker = false
    },
    filterByDate () {
      this.loadSummaryBalance()
      this.loadInitialAndLastBalance()
      this.load()
      this.datePicker = false
    },
    updateTable: async function (data) {
      this.table.options = data
      if (this.$store.state.area) {
        await this.load({
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1))
        })
      }
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }
      if (this.dates.length) {
        params['createdAt>'] = this.$moment(this.dates[0]).startOf('day').toISOString()
        params['createdAt<'] = this.$moment(this.dates[1]).endOf('day').toISOString()
      }
      this.table.loading = true
      try {
        this.balance.set({ restaurant: this.restaurant })
        const { response } = await this.balance.list(params)
        this.table.data = response.data.data.map(balance => {
          if (balance.metadata && balance.metadata.order) {
            const invoicedTotal = ((balance.metadata.order || {}).invoices || []).filter(invoice => invoice.status === 'active').reduce((acc, num) => acc + num.total, 0)
            const creditNoteTotal = ((balance.metadata.order || {}).creditNotes || []).reduce((acc, num) => acc + num.total, 0)
            balance.metadata.order.invoicedTotal = invoicedTotal - creditNoteTotal
          }
          return balance
        })
        this.table.total = response.data.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    async loadInitialAndLastBalance () {
      const params = {}
      if (this.dates.length) {
        params['createdAt>'] = this.$moment(this.dates[0]).startOf('day').toISOString()
        params['createdAt<'] = this.$moment(this.dates[1]).endOf('day').toISOString()
      }
      this.initialAndLastBalance.loading = true
      try {
        const { start, end } = await this.$api.get('/v1/balances/initial-last', params)
        this.initialAndLastBalance.data = {
          start: (start || {}).balanceAmount,
          end: (end || {}).kind === 'outgoing' ? (end || {}).balanceAmount - (end || {}).amount : (end || {}).balanceAmount + (end || {}).amount
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.initialAndLastBalance.loading = false
    },
    async loadSummaryBalance () {
      const params = {}
      if (this.dates.length) {
        params['createdAt>'] = this.$moment(this.dates[0]).startOf('day').toISOString()
        params['createdAt<'] = this.$moment(this.dates[1]).endOf('day').toISOString()
      }
      this.summaryBalance.loading = true
      try {
        const response = await this.$api.get('/v1/balances/summary', params)
        this.summaryBalance.data = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.summaryBalance.loading = false
    },
    async loadAvailableBalance () {
      this.loadingBalance = true
      try {
        this.balance.set({ restaurant: this.restaurant })
        const { response } = await this.balance.detail()
        this.balance.set({ restaurant: this.restaurant, ...response.data })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loadingBalance = false
    },
    viewInvoice: async function (order, invoice) {
      this.$refs.invoice.open(invoice)
    },
    closeInvoiceViewer () {
      this.order = {}
      this.invoiceViewerOpen = false
    },
    closeDialog: function (order) {
      this.dialog = false
      this.orderPanel = false
      this.overlay = false
      this.order = {}
    },
    closeRefundDialog: function (order) {
      this.refundDialog = false
      this.orderPanel = false
      this.overlay = false
      this.orderRefunded = {}
    },
    openOrderDialog (order) {
      this.order = {
        $: {
          id: order
        }
      }
      this.orderPanel = true
    },
    downloadInvoice: async function (order, invoice) {
      const response = await this.$api.get(`/v1/orders/${order}/invoices/${invoice._id}`)
      var element = document.createElement('a')
      element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(response.content))
      element.setAttribute('download', `invoice-${invoice.uuid}`)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    },
    statusName (status) {
      return {
        created: 'Sin enviar',
        sent: 'Enviada',
        confirmed: 'Confirmada',
        canceled: 'Cancelada',
        invoiced: 'Facturada',
        invalid: 'Factura no coincide',
        received: 'Recibida',
        pending_payment: 'Pendiente de pago',
        paid: 'Pagada'
      }[status]
    },
    statusColor (status) {
      return {
        created: 'grey',
        sent: 'grey',
        confirmed: 'info',
        canceled: 'red',
        invoiced: 'info',
        invalid: 'red',
        received: 'primary',
        pending_payment: 'orange',
        paid: 'primary'
      }[status]
    },
    checkTotal (invoiceTotal, total) {
      const maxTotal = total + 0.9
      const minTotal = total - 0.9
      return (invoiceTotal < maxTotal && invoiceTotal > minTotal)
    }
  }
}
</script>
